export function formatInTz(value, timezone, options) {
  if (value == null) return "—";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("ro-RO", {
    timeZone: timezone || "Europe/Bucharest",
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", ...options,
  });
}

export function formatDuration(seconds) {
  if (!seconds || seconds <= 0) return "—";
  const total = Math.round(seconds);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, "0")}m`;
  if (m > 0) return `${m}m ${String(s).padStart(2, "0")}s`;
  return `${s}s`;
}

export function formatBytes(bytes) {
  if (!bytes) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  let value = bytes, i = 0;
  while (value >= 1024 && i < units.length - 1) { value /= 1024; i++; }
  return `${value.toFixed(value >= 100 ? 0 : 1)} ${units[i]}`;
}

export const TIMEZONES_RO = [
  { value: "Europe/Bucharest", label: "România (Europe/Bucharest)" },
  { value: "Europe/Chisinau", label: "Republica Moldova (Europe/Chisinau)" },
  { value: "Europe/Berlin", label: "Germania (Europe/Berlin)" },
  { value: "Europe/Vienna", label: "Austria (Europe/Vienna)" },
  { value: "Europe/Paris", label: "Franța (Europe/Paris)" },
  { value: "Europe/London", label: "Regatul Unit (Europe/London)" },
  { value: "Europe/Madrid", label: "Spania (Europe/Madrid)" },
  { value: "Europe/Rome", label: "Italia (Europe/Rome)" },
  { value: "Europe/Athens", label: "Grecia (Europe/Athens)" },
  { value: "Europe/Istanbul", label: "Turcia (Europe/Istanbul)" },
  { value: "UTC", label: "UTC" },
];

export const COUNTRIES_RO = [
  { value: "RO", label: "România" }, { value: "MD", label: "Republica Moldova" },
  { value: "DE", label: "Germania" }, { value: "AT", label: "Austria" },
  { value: "FR", label: "Franța" }, { value: "UK", label: "Regatul Unit" },
  { value: "ES", label: "Spania" }, { value: "IT", label: "Italia" },
  { value: "GR", label: "Grecia" }, { value: "TR", label: "Turcia" },
  { value: "OTHER", label: "Altă țară" },
];
